<template>
    <div class="wrap">

        <!-- 头部 -->
        <header>
            <div class="h-state" v-if="showFlag === ACTIVE_SHOW && isShowStuResult" v-html="parseActiveTime(deadlineTime)"></div>
            <div class="h-title">{{ hTitle }}</div>
            <div class="h-info" v-if="showFlag === ACTIVE_SHOW && isShowStuResult">
                <span>已参与 <strong>{{ joinNum }}</strong></span>
                <span>未参与 <strong>{{ notJoinNum }}</strong></span>
            </div>
        </header>
        
        <main ref="chooseContent">
            <!-- 云教材活动显示 -->
            <div class="active-show" v-if="showFlag === ACTIVE_SHOW">
                <!-- 任务详情 -->
                <section class="m-detail section-item" v-if="isShowActDetail">
                    <div class="m-detail-wrap">
                        <div class="section-item-title">
                            <span class="section-item-title-l">任务详情</span>
                        </div>

                        <div class="det-book">
                            <div class="det-book-con">
                                <div class="book-info">
                                    <img :src="bookImg" alt="" :id="1" :onerror="notFoundImg">
                                    <div class="book-con">
                                        <div class="book-name">{{ bookName }}</div>
                                        <div class="book-author">
                                            <span>{{ bookAuthor }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="book-section book-list">
                                    <div class="sec-title"><img src="../assets/image/icon_mission_content@2x.png" alt="">学习内容</div>
                                    <ul>
                                        <li v-for="item in chapter" :key="item.id">
                                            <span>{{ item.title }}</span>
                                            <ul v-for="subItem in item.sections" :key="subItem.id">
                                                <li>{{ subItem.title }}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>

                                <div class="book-section book-demand" >
                                    <div class="sec-title"><img src="../assets/image/icon_mission_description@2x.png" alt=""> 学习要求</div>
                                    <div class="sec-con">{{ learnDemand }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- 学生的完成情况 -->
                <section :data-is-complete="hasStudyInfo" class="m-complete section-item" :class="hasStudyInfo ? '' : 'm-complete-null'" v-if="isShowStuResult">
                    <div class="m-complete-wrap">
                        <div class="section-item-title">
                            <div class="section-item-title-l">
                                <span>学生的完成情况</span>
                            </div>

                            <!-- 排序 -->
                            <div class="section-item-title-r">
                                <div class="filter-box filter-content">
                                    <span :title="currentContent">{{ currentContent }}</span>
                                </div>

                                <div class="filter-box filter-time">
                                    <span>{{ sortType }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 学生信息 -->
                        <div class="section-item-con">
                            <ul v-if="hasStudyInfo">
                                <li v-for="(item) in studentResults" :key="item.user.user_id">
                                    <div class="stu-item" 
                                        :class="parseCompleteLevel(item.reading_process)"
                                        :data-reading-process="item.reading_process" 
                                        :data-total-duration="item.total_duration"
                                        :data-video-watching-duration="item.video_watching_duration" 
                                        :data-quiz-right-rate="item.quiz_right_rate" 
                                        :data-practice-count="item.practice_count"
                                        :data-full-name="item.full_name" 
                                        :data-full-id="item.user.user_id" 
                                        :data-student-no="item.user.student_no">
                                        <img :src="item.user.avatar_url ? item.user.avatar_url : avatarUrl" alt=""
                                            class="stu-img">

                                        <div class="stu-info">
                                            <div class="stu-name">
                                                <span :title="item.user.full_name">{{ item.user.member_name }}</span>
                                                <span :title="item.user.student_no">{{ item.user.member_no }}</span>

                                                <!-- 学习时长 -->
                                                <span class="stu-pro-text" v-html="parseTotalDuration(item.total_duration || '<strong>0</strong>分钟')">
                                                
                                                </span>
                                            </div>
                                            <div class="stu-info-pro">
                                                <div class="stu-info-bar">
                                                    <div class="stu-info-bar-inner" :style="'width:' + (item.reading_process * 100).toFixed(2) + '%'"></div>
                                                </div>
                                                <span class="stu-pro-num">{{ (item.reading_process * 100).toFixed(2) + '%' }}</span>
                                            </div>
                                        </div>

                                        <div class="stu-type">
                                            <span>学习时长</span>
                                            <span>学习进度</span>
                                        </div>

                                        <div class="stu-time">
                                            <span class="stu-time-num" v-html="parseStudentDetail('TIME', item.video_watching_duration)"></span>
                                            <span class="stu-time-des">
                                                <img src="../assets/image/ic_learning_study_normal@2x.png" alt="">
                                                视频学习
                                            </span>
                                        </div>

                                        <div class="stu-test">
                                            <span class="stu-test-num" v-html="parseStudentDetail('TEST', item.quiz_right_rate)"></span>
                                            <span class="stu-test-des">
                                                <img src="../assets/image/ic_learning_correct_normal@2x.png" alt="">
                                                测试正确率
                                            </span>
                                        </div>

                                        <div class="stu-num">
                                            <span class="stu-num-num" v-html="parseStudentDetail('NUM', item.total_practice_count)"></span>
                                            <span class="stu-num-des">
                                                <img src="../assets/image/ic_learning_exercise_normal@2x.png" alt="">
                                                交互练习
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <div class="stu-null" v-else>
                                <img src="../assets/image/pic_mo_loading.png" alt="">
                                <p>小墨正在努力统计结果，请稍后重试</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <!-- 学习报告 -->
            <div class="learn-report" v-else>
                <!-- 全书学习 -->
                <section class="totle-book" v-if="showFlag===TOTLE_BOOK">
                    <div class="tb-t">
                        <!-- 左上 -->
                        <div class="tb-tl">
                            <div class="tl-book">
                                <img class="book-img" :src="bookPic" alt="" :onerror="notFoundImg">

                                <div class="tl-book-info">
                                    <span class="info-name">《 {{ bookTitle }} 》</span>
                                    <span class="info-des">教材学习时长班课排名</span>
                                    <span class="info-level">第 {{ ranking }} 名</span>
                                </div>
                            </div>

                            <div class="tl-summary">
                                <div class="summary-item">
                                    <span class="summary-item-num">{{ parseProToPercent(totlePro) }}</span>
                                    <span class="summary-item-des">学习总进度</span>
                                </div>

                                <div class="summary-item">
                                    <span class="summary-item-num" v-html="parseSecondValue(videoTime)"></span>
                                    <span class="summary-item-des">视频学习</span>
                                </div>

                                <div class="summary-item">
                                    <span class="summary-item-num" v-html="parseSecondValue(totleStudyTime)"></span>
                                    <span class="summary-item-des">学习总时长</span>
                                </div>

                                <div class="summary-item">
                                    <span class="summary-item-num" v-html="parseSecondValue(readTime)"></span>
                                    <span class="summary-item-des">阅读时长</span>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 右上 -->
                        <div class="tb-tr tb-r">
                            <div class="r-title">
                                <img src="../assets/image/icon_note@2x.png" alt="">
                                <span>笔记标注</span>
                            </div>

                            <div class="r-item">
                                <span class="r-item-des">笔记</span>
                                <span class="r-item-num"><strong>{{ noteCount }}</strong> 条</span>
                            </div>

                            <div class="r-item">
                                <span class="r-item-des">高亮</span>
                                <span class="r-item-num"><strong>{{ heightLight }}</strong> 条</span>
                            </div>
                        </div>
                    </div>

                    <div class="tb-b">
                        <!-- 左下 -->
                        <div class="tb-bl">
                            <div class="l-item">
                                <div class="l-item-title">
                                    <img src="../assets/image/icon_exercise@2x.png" alt="">
                                    <span>交互练习</span>
                                </div>

                                <div class="l-item-value" v-if="practiceCount"><strong>{{practiceCount}}</strong>&nbsp;次</div>
                                <div class="l-item-value" v-else>暂无记录</div>
                            </div>

                            <div class="l-item">
                                <div class="l-item-title">
                                    <img src="../assets/image/icon_test_right@2x.png" alt="">
                                    <span>测试正确率</span>
                                </div>

                                <div class="l-item-value"><strong>{{ parseProToPercent(quizRate) }}</strong></div>
                            </div>

                            <div class="l-item">
                                <div class="l-item-title">
                                    <img src="../assets/image/icon_studytime@2x.png" alt="">
                                    <span>最长连续学习</span>
                                </div>

                                <div class="l-item-value" v-html="parseSecondValueForMaxContinue(maxContinueLearn)"></div>
                            </div>

                            <div class="l-item">
                                <div class="l-item-title">
                                    <img src="../assets/image/icon_extend@2x.png" alt="">
                                    <span>扩展学习</span>
                                </div>

                                <div class="l-item-value"><strong>{{ extendLearn }}</strong>&nbsp;次</div>
                            </div>
                        </div>

                        <!-- 右下 -->
                        <div class="tb-br tb-r">
                            <div class="r-title">
                                <img src="../assets/image/icon_disscuss@2x.png" alt="">
                                <span>讨论</span>
                            </div>

                            <div class="r-item">
                                <span class="r-item-des">发起讨论</span>
                                <span class="r-item-num"><strong>{{ initTalk }}</strong>&nbsp;条</span>
                            </div>

                            <div class="r-item">
                                <span class="r-item-des">参与讨论</span>
                                <span class="r-item-num"><strong>{{ joinTalk }}</strong>&nbsp;条</span>
                            </div>
                        </div>
                    </div>

                    
                </section>

                <!-- 章节学习 -->
                <section class="section-learn" v-if="showFlag===SECTION_LEARN && !isNoData">
                    <!-- 信息总览 -->
                    <div class="section-learn-top">
                        <div class="top-l">
                            <span class="top-value">{{ this.parseProToPercent(totleBookPro) }}</span>
                            <span class="top-des">{{ sectionLearnDesLeft }}</span>
                        </div>

                        <div class="top-r">
                            <span class="top-value" v-html="parseSecondValue(totleBookLearnTime)"></span>
                            <span class="top-des">{{ sectionLearnDesRight }}</span>
                        </div>
                    </div>

                    <!-- 章节信息 -->
                    <div class="secion-learn-con">
                        <ul>
                            <li v-for="(item) in chapter" :key="item.id">
                                <div class="chapter-item">
                                    <div class="chapter-title">{{ item.title }}</div>

                                    <div class="chapter-info">
                                        <ul>
                                            <li v-for="(subItem) in item.sub" :key="subItem.type">
                                                <img :src="parseSectionLearnType(subItem.type).imgUrl" alt="">
                                                <div class="chapter-info-detail">
                                                    <span class="detail-des">{{ parseSectionLearnType(subItem.type).text }}</span>
                                                    <span class="detail-value" v-html="parseSectionLearnValue(subItem.type, subItem.value)"></span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>

                <!-- 视频学习 -->
                <section class="video-learn" v-if="showFlag===VIDEO_LEARN && !isNoData">
                    <!-- <div class="video-learn-wrap"> -->
                        <!-- 总览 -->
                        <div class="video-learn-top">
                            <span v-html="parseSecondValue(totleVideoTime)"></span>
                            <span>观看视频总时长</span>
                        </div>

                        <!-- 章节视频信息 -->
                        <div class="video-learn-info">
                            <ul>
                                <li v-for="(item) in videoData" :key="item.id">
                                    <div class="video-item">
                                        <span class="chapter-name">{{ item.title }}</span>

                                        <ul>
                                            <li class="video-sub-item" v-for="(subItem) in item.sub" :key="subItem.id">
                                                <span>{{ subItem.title }}</span>
                                                <span class="video-sub-item-value">{{ parseProToPercent(subItem.value) }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    <!-- </div> -->
                </section>

                <!-- 练习测试 -->
                <section class="test" v-if="showFlag===TEST && !isNoData">
                    <!-- 总览 -->
                    <div class="test-top">
                        <div class="test-top-item">
                            <span class="test-top-value">{{ totlePracticeTimes }}&nbsp;次</span>
                            <span class="test-top-des">练习总次数</span>
                        </div>

                        <div class="test-top-item">
                            <span class="test-top-value">{{ totlePracticeCount }}&nbsp;个</span>
                            <span class="test-top-des">练习总个数</span>
                        </div>

                        <div class="test-top-item">
                            <span class="test-top-value">{{ parseProToPercent(rightRate) }}</span>
                            <span class="test-top-des">平均正确率</span>
                        </div>
                    </div>

                    <!-- 章节视频信息 -->
                    <div class="test-info">
                        <!-- 章列表 -->
                        <ul>
                            <li v-for="(item,index) in practiceData" :key="index">
                                <div class="test-item">
                                    <span class="chapter-name">{{ item.title }}</span>

                                    <!-- 练习列表 -->
                                    <ul>
                                        <li class="test-sub-item" 
                                        v-for="(subItem, i) in item.sub" 
                                        :id="(subItem.type === 'TEST' && subItem.id === sectionDetail.id) ? 'detail' : ''"
                                        :class="(subItem.type === 'TEST' && subItem.id === sectionDetail.id) ? 'test-sub-item-big' : ''"
                                        :key="i" >
                                            <span class="section-name" :class="parseTestType(subItem.type)">{{ subItem.title }}</span>
                                            <span class="test-sub-item-value">{{ subItem.type === 'TEST' ? parseProToPercent(subItem.value) :  (subItem.value || 0) + ' 次'}}</span>

                                            <div class="test-detail" 
                                            v-if="subItem.type === 'TEST' && subItem.id === sectionDetail.id">
                                                <div class="detail-top">
                                                    <div class="detail-top-l">
                                                        <span>{{ parseProToPercent(sectionDetail.newRate) }}</span>
                                                        <span>最新成绩（正确率）</span>
                                                    </div>

                                                    <div class="detail-top-r">
                                                        <span>{{ parseProToPercent(sectionDetail.bestRate) }}</span>
                                                        <span>最优成绩（正确率）</span>
                                                    </div>
                                                </div>

                                                <div class="detail-list">
                                                    <!-- 练习详情列表 -->
                                                    <ul>
                                                        <li>
                                                            <span>测试次数</span>
                                                            <span>{{ sectionDetail.testTimes + ' 次' }}</span>
                                                        </li>

                                                        <li v-for="(rateItem, index) in sectionDetail.rate" :key="index" :class="calculateTestDetailIcon(index, rateItem.value)">
                                                            <span class="detail-date">{{ parseTestDetailDate(rateItem.date) }}</span>
                                                            <span class="detail-value">正确率：<span>{{ parseProToPercent(rateItem.value) }}</span></span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div class="gap" style="height: 100vh;" v-if="isShowGap"></div>
                    </div>
                </section>

                <!-- 暂无记录页面 -->
                <section class="no-data" v-if="isNoData">
                    <img src="../assets/image/no_data.png" alt="">
                    <p>暂无记录</p>
                </section>
            </div>
        </main>
    </div>
</template>

<script type="text/javascript">
import moment from 'moment';
import avatarUrl from '../assets/image/user-avatarUrl.jpg';

import sectionImg1 from '../assets/image/icon_schedule@2x.png';
import sectionImg2 from '../assets/image/icon_learninglength@2x.png';
import sectionImg3 from '../assets/image/icon_lengthofreading@2x.png';
import sectionImg4 from '../assets/image/icon_videotimelength@2x.png';
import sectionImg5 from '../assets/image/icon_testscore@2x.png';
import sectionImg6 from '../assets/image/icon_exercise_op@2x.png';
import sectionImg7 from '../assets/image/icon_label@2x.png';
import sectionImg8 from '../assets/image/icon_abc@2x.png';
import sectionImg9 from '../assets/image/icon_longestlearningtime@2x.png';
import sectionImg10 from '../assets/image/icon_extendedlearning@2x.png';
import sectionImg11 from '../assets/image/icon_launchdiscussion@2x.png';
import sectionImg12 from '../assets/image/icon_discussing@2x.png';
import defalultBookImg from '../assets/image/loading_80@2x.png'

export default {
    data: function() {
        return {
            // 显示页面标志
            ACTIVE_SHOW: 'ACTIVE_SHOW',
            TOTLE_BOOK: 'TOTLE_BOOK',
            SECTION_LEARN: 'SECTION_LEARN',
            VIDEO_LEARN: 'VIDEO_LEARN',
            TEST: 'TEST',
            booklearnId : '',
            // 是否显示云教材详情
            isShowActDetail: false,
            isShowStuResult: true, //是否显示学生学习信息
            showFlag: 'TOTLE_BOOK',
            // showFlag: 'VIDEO_LEARN',
            hasStudyInfo: true,// 是否有学生信息
            hState: '',
            deadlineTime: '',
            booklearnTitle: '',
            hTitle: '',
            avatarUrl: avatarUrl,
            joinNum: 0,
            notJoinNum :0,
            sortType: '学习时长从低到高',
            // 学生的完成情况
            studentResults: [],
            // 任务详情 章节
            chapter: [],
            currentContent: '全部内容',// 当前内容
            learnDemand: '',// 学习要求
            bookName: '',
            bookAuthor: '',
            bookImg: '',

            isNoData: false,
            notFoundImg: `this.src="${defalultBookImg}"`,

            // 全书学习
            bookTitle: '机械工程制图手册',
            bookPic: '',
            ranking: '1',
            totlePro: '2.00%',
            videoTime: 2000,
            totleStudyTime: 3333,
            readTime: 4444,
            noteCount: 2,
            heightLight: 1,
            practiceCount: 1,
            quizRate: '22.22%',
            maxContinueLearn: 4444,
            extendLearn: 2,
            initTalk: 3,
            joinTalk: 2,

            // 章节学习
            totleBookPro: '11.11%',
            totleBookLearnTime: 11111,
            chapterName: '',
            sectionLearnDesLeft: '全书学习总进度',
            sectionLearnDesRight: '全书学习总时长',
            chapter: [],

            // 视频学习
            totleVideoTime: 111111,
            videoData: [],

            // 练习测试
            totlePracticeTimes: 11,
            totlePracticeCount: 12,
            rightRate: '111%',
            practiceData: [],
            sectionDetail: {},
            isShowGap:false,
        };
    },

    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
                }
    },

    mounted() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },
    
    watch: {
        currentShow(newValue, old) {
            if (newValue === 'noController') {
                // 处理手机杀进程的情况
                this.isShowActDetail = false;
            }
        }
    },
    
    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
        // this.componentId = null;
    },

    methods: {
        windowMessageHandler(e) {
            const msg = e.data;
            if (! msg) return;
            if (! msg.eventName) return;
            if (this.isLock) return;

            const msgData = msg.data;
            switch (msg.eventName) {
                case 'booklearn.showResults':
                    this.showResults(msgData);
                    break;
                case 'booklearn.showDetail':
                    this.showDetail(msgData);
                    break;
                case 'booklearn.hideDetail':
                    this.hideDetail(msgData);
                    break;
                case 'booklearn.sortResults':
                    this.sortResults(msgData);
                    break;
                case 'booklearn.report.show':
                    this.reportShow(msgData);
                    break;
                case 'booklearn.report.hide':
                    this.reportHide(msgData);
                    break;
                case 'common.moveJoystick':
                    if (this.componentId) this.moveJoystick(msgData);
                    break;
            }
        },

        showResults(data) {
            this.showFlag = this.ACTIVE_SHOW;
            this.booklearnId = data.booklearnId;
            this.isShowStuResult = true;
            this.studentResults = data.rows || [];
            this.hTitle = data.title;
            this.booklearnTitle = data.title;
            this.hState = data.status;
            this.joinNum = data.join_member_count;
            this.notJoinNum = data.not_join_member_count;
            this.hasStudyInfo = data.archive_completed === 'Y';
            this.deadlineTime = data.deadline_time || '';
            this.currentContent = data.current_content || '全部内容';
            this.isShowActDetail = false;
            this.scrollToTop();
            this.sortResults({
                sortBy: data.sort_by || 'LEARNING_DURATION',
                sortType: data.sort_type || "ASC"
            });
        },

        showDetail(data) {
            this.showFlag = this.ACTIVE_SHOW;
            if (data.booklearnId !== this.booklearnId) {
                // 从锁屏进入任务详情 再解锁情况 取消学生信息显示
                this.studentResults = [];
                this.isShowStuResult = false;
            }
            this.isShowActDetail = true;
            this.hTitle = data.title;
            this.bookName = data.learning_content.title;
            this.bookAuthor = data.author;
            this.bookImg = data.learning_content.cover_image_url;
            this.chapter = data.learning_content.chapters;
            this.learnDemand = data.learning_requirements || '未设置';
        },

        hideDetail(data) {
            this.isShowActDetail = false;
        },

        sortResults(data = {
            sortBy: 'LEARNING_DURATION',
            "sortType": "ASC"
        }) {
            if (this.isLock) return;
            if (!data.sortBy) return;
            let sortFn;
            switch (data.sortBy) {
                case 'LEARNING_DURATION':
                    sortFn = this.sortFn('total_duration', data.sortType);
                    this.sortType = data.sortType === 'ASC' ? '学习时长从低到高' : '学习时长从高到低';
                    break;
                case 'LEARNING_PROGRESS':
                    sortFn = this.sortFn('reading_process', data.sortType);
                    this.sortType = data.sortType === 'ASC' ? '学习进度从低到高' : '学习进度从高到低';
                    break;
                case 'QUIZ_RIGHT_RATE':
                    sortFn = this.sortFn('quiz_right_rate', data.sortType);
                    this.sortType = data.sortType === 'ASC' ? '测试正确率从低到高' : '测试正确率从高到低';
                    break;
                case 'VIDEO_DURATION':
                    sortFn = this.sortFn('video_watching_duration', data.sortType);
                    this.sortType = data.sortType === 'ASC' ? '视频学习时长从低到高' : '视频学习时长从高到低';
                    break;
                case 'PRACTICE_COUNT':
                    sortFn = this.sortFn('practice_count', data.sortType);
                    this.sortType = data.sortType === 'ASC' ? '交互练习次数从少到多' : '交互练习次数从多到少';
                    break;
                case 'STUDENT_NUM':
                    sortFn = this.sortFn('member_no', data.sortType);
                    this.sortType = data.sortType === 'ASC' ? '学号从小到大' : '学号从大到小';
                    break;
            }

            if (sortFn) {
                this.$set(this.studentResults, this.studentResults.sort(sortFn));
            }
        },

        reportShow(data) {
            switch (data.type) {
                case 'SUMMARY':

                    this.showFlag = this.TOTLE_BOOK;
                    this.isNoData = false;
                    this.hTitle = '学习报告 - 全书学习';
                    this.bookTitle = data.bookTitle;
                    this.bookPic = data.bookPic;
                    this.ranking = data.ranking;
                    this.totlePro = data.totlePro;
                    this.videoTime = data.videoTime;
                    this.totleStudyTime = data.totleStudyTime || '0 分钟';
                    this.readTime = data.readTime || '0 分钟';
                    this.noteCount = data.noteCount || 0;
                    this.heightLight = data.heightLight || 0;
                    this.practiceCount = data.practiceCount;
                    this.quizRate = data.quizRate;
                    this.maxContinueLearn = data.maxContinueLearn || '<strong>0</strong>&nbsp;分钟';
                    this.extendLearn = data.extendLearn || 0;
                    this.initTalk = data.initTalk || 0;
                    this.joinTalk = data.joinTalk || 0;
                    break;
                case 'CHAPTER_AND_SECTION':
                case 'CHAPTER_DETAIL':
                    this.showFlag = this.SECTION_LEARN;
                    if (data.chapter == undefined || !data.chapter.length) {
                        this.isNoData = true;
                        this.hTitle = '学习报告 - 章节学习';
                        return;
                    }

                    this.isNoData = false;
                    this.hTitle = data.chapterName || '学习报告 - 章节学习';
                    this.totleBookPro = data.totleBookPro;
                    this.totleBookLearnTime = data.totleBookLearnTime;
                    this.chapterName = data.chapterName || '学习报告 - 章节学习';
                    this.sectionLearnDesLeft = data.chapterName ? '本章学习总进度' : '全书学习总进度';
                    this.sectionLearnDesRight = data.chapterName ? '本章学习总时长' : '全书学习总时长';
                    this.chapter = data.chapter;
                    break;
                    break;
                case 'VIDEO':
                    this.showFlag = this.VIDEO_LEARN;
                    if (data.videoData == undefined || !data.videoData.length) {
                        this.isNoData = true;
                        this.hTitle = '学习报告 - 视频学习';
                        return;
                    }
                    
                    this.isNoData = false;
                    this.hTitle = '学习报告 - 视频学习';
                    this.totleVideoTime = data.totleVideoTime;
                    this.videoData = data.videoData;
                    break;
                case 'PRACTICE_AND_QUIZ':
                    this.showFlag = this.TEST;
                    if (data.practiceData == undefined || !data.practiceData.length) {
                        this.isNoData = true;
                        this.hTitle = '学习报告 - 练习测试';
                        return;
                    }
                    
                    this.isNoData = false;
                    this.sectionDetail = {};
                    this.hTitle = '学习报告 - 练习测试';
                    this.totlePracticeTimes = data.totlePracticeTimes;
                    this.totlePracticeCount = data.totlePracticeCount;
                    this.rightRate = data.rightRate;
                    this.practiceData = data.practiceData;
                    this.isShowGap = false;

                    this.$nextTick(() => {
                        this.$refs.chooseContent.scrollTop=0;
                    })
                    break;
                case 'QUIZ_DETAIL':
                    if (data.rate == undefined || !data.rate.length) {
                        this.isNoData = true;
                        this.hTitle = '学习报告 - 练习测试';
                        return;
                    }
                    
                    this.isNoData = false;
                    this.sectionDetail = data;
                    this.isShowGap = true;
                    this.$nextTick(() => {
                        this.$refs.chooseContent.scrollTop=this.$refs.chooseContent.scrollTop + document.getElementById("detail").getBoundingClientRect().top - 80;
                    })
                    break;
            }
        },

        reportHide(data) {
            this.showFlag = this.ACTIVE_SHOW;
            this.isShowActDetail = false;
            this.hTitle = this.booklearnTitle;
        },

        /**
         * 学习详情排序
         * @param {string} dataType 排序字段
         * @param {string} flag 升降序
         * @returns {function} 排序函数
         */
        sortFn(dataType, flag) {
            const order = flag === 'DESC' ? 1 : -1;
            return function(a, b) {
                let aValue;
                let bValue;
                if (dataType === 'member_no') {
                    aValue = a.user.member_no;
                    bValue = b.user.member_no;
                } else {
                    aValue = a[dataType];
                    bValue = b[dataType];
                }
                
                let aName = a.user.member_name;
                let bName = b.user.member_name;
                let aId = a.user.user_id;
                let bId = b.user.user_id;

                if (+aValue && +bValue && dataType !== 'member_no') {
                    aValue = +aValue;
                    bValue = +bValue;
                }

                if (aValue != bValue ) {
                    // 值不相等根据值排
                    return aValue < bValue ? order : -order;
                } else if (aName != bName) {
                    // 值相等 根据名字排序 0-9 a-z 
                    // 数字在字母前边 字母在汉子前边
                    if (/[0-9]/.test(aName[0]) && !/[0-9]/.test(bName[0])) return -1;
                    if (/[0-9]/.test(bName[0]) && !/[0-9]/.test(aName[0])) return 1;
                    if (/[a-z]/.test(aName[0]) && !/[a-z]/.test(bName[0])) return -1;
                    if (/[a-z]/.test(bName[0]) && !/[a-z]/.test(aName[0])) return 1;
                    return (aName + '').localeCompare(bName + '');
                } else {
                    // 值相等 名字相等 根据学号排
                    return (aId + '').localeCompare(bId + '');
                }
            }
        },

        /**
         * 解析学生的学习时长
         * @param {number} num 以秒为单位的学习时长
         * @returns {string} 显示内容
         */
        parseTotalDuration(num) {
            if (typeof num !== 'number') return num;
            if (num < 60) {
                return '不足<strong>1</strong>分钟';
            } else if (num < 60 * 60) {
                let min = parseInt(num / 60, 10);
                if (parseInt(num % 60) >= 30) {
                    min++;
                }
                return `<strong>${min}</strong><span>分钟</span>`;
            } else {
                let hour = parseInt(num / 60 / 60, 10);
                let min = Math.round((num - hour * 60 * 60) / 60);
                return `<strong>${hour}</strong><span>小时</span><strong>${min}</strong><span>分钟</span>`;
            }
        },

        /**
         * 解析学生的完成样式
         * @param {number} value 学习进度
         * @returns {string} 显示内容
         */
        parseCompleteLevel(value) {
            if (value <= 0.2999) {
                return 'stu-item-level1';
            } else if (value < 0.6999) {
                return 'stu-item-level2';
            } else {
                return 'stu-item-level3';
            }
        },

        /**
         * 解析学生的详细学习信息
         * @param {string} flag 区别标志
         * @param {number} value 值
         * @returns {string} 显示内容
         */
        parseStudentDetail(flag, value) {
            if (!value) return '暂无记录';
            switch (flag) {
                case 'TIME':
                    let minute = parseInt(value / 60, 10);
                    if (parseInt(value % 60) >= 30) {
                        minute++;
                    }
                    return `<strong>${minute}</strong> <span>分钟</span>`;
                    break;
                case 'TEST':
                    return `<strong>${Math.round(value * 100)}</strong> <span>%</span>`;
                    break;
                case 'NUM':
                    return `<strong>${value}</strong> <span>次</span>`;
                    break;
            }
        },

        parseActiveTime(time) {
            if (this.hState !== 'END') {
                if (!time) return '<span>任务已开始</span>';

                let deadlineTime = new Date(time);
                let nowTime = new Date();
                let diff = deadlineTime - nowTime;
                const ONE_DAY = 1000 * 60 * 60 * 24;
                const ONE_HOUR = 1000 * 60 * 60;
                const ONE_MIN = 1000 * 60;

                if (diff > ONE_DAY) {
                    let dayNum = parseInt(diff / ONE_DAY, 10);
                    let hourNum = parseInt((diff - dayNum * ONE_DAY) / ONE_HOUR, 10);
                    
                    return `距任务结束还有 <strong style="color: #00bbdd">${dayNum}</strong> 天 <strong style="color: #00bbdd">${hourNum}</strong> 小时`;
                } else {
                    let hourNum = parseInt(diff / ONE_HOUR, 10);
                    let minNum = parseInt((diff - hourNum * ONE_HOUR) / ONE_MIN, 10);
                    if (parseInt(diff - hourNum * ONE_HOUR) % ONE_MIN >= 0.5 * ONE_MIN) {
                        minNum++;
                        if (minNum === 60) {
                            minNum = 0;
                            hourNum++;
                        }
                    }
                    if (minNum) {
                        return `距任务结束还有 <strong style="color: #FF4C4C">${hourNum}</strong> 小时 <strong style="color: #FF4C4C">${minNum}</strong> 分钟`;
                    } else {
                        return `距任务结束还有 <strong style="color: #FF4C4C">${hourNum}</strong> 小时`;
                    }
                }
            } else {
                return '<span style="color: #979DA1;">任务已结束</span>';
            } 
        },

        /**
         * 解析学习报告值
         */
        parseSecondValue(value) {
            if (!value) return '暂无记录';
            if (typeof value !== 'number') return value;

            const time = this.formatSeconds(value);
            if (time.hour) {
                if (time.minite) {
                    return `<strong>${time.hour}</strong>&nbsp;小时&nbsp;<strong>${time.minite}</strong>&nbsp;分钟`;
                } else {
                    return `<strong>${time.hour}</strong>&nbsp;小时&nbsp;<strong>`;
                }
            } else if (time.minite < 1) {
                return `不足&nbsp;1&nbsp;分钟`;
            } else {
                return `${time.minite} 分钟`;
            }
        },

        parseSecondValueForMaxContinue(value) {
            if (!value) return '暂无记录';
            if (typeof value !== 'number') return value;

            const time = this.formatSeconds(value, false);
            if (time.hour) {
                if (time.minite) {
                    return `<strong>${time.hour}</strong>&nbsp;小时&nbsp;<strong>${time.minite}</strong>&nbsp;分钟`;
                } else {
                    return `<strong>${time.hour}</strong>&nbsp;小时&nbsp;<strong>`;
                }
            } else if (time.minite < 1) {
                return `不足<strong>1</strong>&nbsp;&nbsp;分钟`;
            } else {
                return `<strong>${time.minite}</strong>&nbsp;分钟`;
            }
        },

        parseSectionLearnType(type) {
            switch (type) {
                case 'LEARN_PRO':
                    return {
                        text: '学习进度',
                        imgUrl: sectionImg1
                    };
                    break;
                case 'TOTLE_LEARN_TIME':
                    return {
                        text: '学习总时长',
                        imgUrl: sectionImg2
                    };
                    break;
                case 'READING_TIME':
                    return {
                        text: '阅读时长',
                        imgUrl: sectionImg3
                    };
                    break;
                case 'VIDEO_LEARN':
                    return {
                        text: '视频学习',
                        imgUrl: sectionImg4
                    };
                    break;
                case 'QUIE_RATE':
                    return {
                        text: '测试平均正确率',
                        imgUrl: sectionImg5
                    };
                    break;
                case 'PROCTICE_COUNT':
                    return {
                        text: '交互练习',
                        imgUrl: sectionImg6
                    };
                    break;
                case 'NOTE':
                    return {
                        text: '笔记',
                        imgUrl: sectionImg7
                    };
                    break;
                case 'HIGH_LIGHT':
                    return {
                        text: '高亮',
                        imgUrl: sectionImg8
                    };
                    break;
                case 'MAX_CONTINUE_LEARN':
                    return {
                        text: '最长连续学习',
                        imgUrl: sectionImg9
                    };
                    break;
                case 'EXTEND_LEARN':
                    return {
                        text: '扩展学习',
                        imgUrl: sectionImg10
                    };
                    break;
                case 'INIT_TALK':
                    return {
                        text: '发起讨论',
                        imgUrl: sectionImg11
                    };
                    break;
                case 'JOIN_TALK':
                    return {
                        text: '参与讨论',
                        imgUrl: sectionImg12
                    };
                    break;
                default :
                    return '';
            }
        },

        parseSectionLearnValue(type, value) {
            switch (type) {
                case 'LEARN_PRO':
                case 'QUIE_RATE':
                    return this.parseProToPercent(value);
                    break;
                case 'TOTLE_LEARN_TIME':
                case 'READING_TIME':
                case 'MAX_CONTINUE_LEARN':
                    return this.parseSecondValue(value);
                    break;
                case 'VIDEO_LEARN':
                    return this.parseSecondValue(value);
                case 'PROCTICE_COUNT':
                    return `${value}&nbsp;次`;
                    break;
                case 'NOTE':
                case 'HIGH_LIGHT':
                    return `${value}&nbsp;条`;
                    break;
                    break;
                case 'EXTEND_LEARN':
                case 'INIT_TALK':
                case 'JOIN_TALK':
                    return `${value}&nbsp;次`
                    break;
                default :
                    return '';
            }
        },

        parseTestType(type) {
            switch (type) {
                case 'PRACTICE':
                    return 'i-practice';
                    break;
                case 'TEST':
                    return 'i-test';
                default: 
                    return '';
            }
        },

        parseProToPercent(value) {
            if (!value || value === 0) return '0%';
            if (value === 1) return '100%';
            let result = (value * 100).toFixed(2) + '%';
            result === '0.00%' ? result = '0%' : '';
            result === '100.00%' ? result = '100%' : '';        

            return result;
        },

        parseTestDetailDate(string) {
            let date = new Date(string);
            let now = new Date();
            if (date.getFullYear() === now.getFullYear 
            && date.getMonth() ===  now.getMonth()
            && date.getDate() === now.getDate()) {
                return `今天 ${date.getHours()}:${date.getMinutes()}`
            } else {
                return moment(date).format('YYYY-MM-DD');
            }
        },


        formatSeconds(value, flag = true) {
            if (!value) return '暂无记录';
            let theTime = parseInt(value);// 秒
            let theTime1 = 0;// 分
            let theTime2 = 0;// 小时
            if (theTime > 60) {
                theTime1 = parseInt(theTime / 60);
                theTime = parseInt(theTime % 60);
                if (theTime % 60 >= 30 && flag) theTime1++;
                if (theTime1 > 60) {
                    theTime2 = parseInt(theTime1 / 60);
                    theTime1 = parseInt(theTime1 % 60);
                }
            }
            
            return {
                second: theTime,
                minite: theTime1,
                hour: theTime2,
            }
        },

        calculateTestDetailIcon(index, value) {
            if (!this.sectionDetail.rate) return;
            if (index === this.sectionDetail.rate.length - 1) {
                return 'new'
            } else if (value === this.sectionDetail.bestRate) {
                return 'best'
            } else {
                return '';
            }
        },

        moveJoystick: function(msgData) {
            let direction = msgData.direction;
            let box = this.$refs.chooseContent;
            // let chooseContentForNew = this.$refs.chooseContentForNew;

            this.boxOfElement(direction,box);
        },

        boxOfElement: function(direction,box) {
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                box.scrollTop -= 40;
            } else if (direction === 'DOWN') {
                box.scrollTop += 40;
            } else {
                return;
            }
        },

        scrollToTop() {
            let box = this.$refs.chooseContent;
            box.scrollTop = 0;
        },
    }
};
</script>

<style lang="scss" scoped>
.wrap {
    overflow: auto;
    // display: flex;
    // flex-direction: column;
    * {
        box-sizing: border-box;
        text-align: left;
    }
    /deep/ strong {
        font-weight: normal;
    }

    header{
        height: 80px;
        display: flex;
        align-items: center;
        color: #fff;
        background-color: #191919;
        width: 100%;
        // position: fixed;
        // top: 0;
        // z-index: 999;

        .h-state,
        .h-info {
            width:340px;
            font-size :18px;
            text-align: left;
            padding-left: 40px;
            color: #BBC2C6;
        }
        .h-state {
            /deep/ strong {
                font-size: 22px;
            }
        }
        
        .h-info {
            padding-left: 0px;
            height: 100%;
            display: flex;
            align-items: center;
            span {
                height: 100%;
                display: flex;
                align-items: center;
                white-space: nowrap;
                &:nth-child(1) {
                    margin-left: auto;
                }
                &:nth-child(2) {
                    strong {
                        margin-right: 30px;
                    }
                }
            }
            strong {
                font-size: 30px;
                line-height: 36px;
                margin: 0 40px 0 10px;
                color: #fff;
                font-weight: 700;
            }
        }
        .h-title {
            flex: 1;
            font-size: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
        }
    }

    main {
        flex: 1;
        overflow-y: auto;
        height: calc(100% - 80px);
        // 云教材活动显示
        .active-show {
            // width: 1280px;
            // margin: 0 auto;
            .section-item {
                // background: #fff;
                background: #191919;
            }
            .section-item .section-item-title {
                height: 68px;
                display: flex;
                align-items: center;
                position: relative;
                color: #fff;
                font-size: 28px;
            }
            .section-item .section-item-title .section-item-title-l {
                margin-right: auto;
                padding-left: 28px;
            }
            .section-item .section-item-title .section-item-title-l::before {
                content: '';
                position: absolute;
                left: 0px;
                width: 10px;
                height: 28px;
                background-color: #00BBDD;
                top: 50%;
                transform: translateY(-50%);
            }
            .section-item .section-item-title .section-item-title-r {
                display: flex;
                position: relative;
            }
            .section-item .section-item-title .section-item-title-r .filter-content >span{
                // margin-right: 36px;
                padding-right: 20px;
                margin-right: 20px;
                border-right: 1px solid #fff;
            }


            .m-detail {
                padding: 0 40px;
                background: #191919;
            }
            .m-detail-wrap,
            .m-complete-wrap {
                width: 1200px;
                margin: 0 auto;
            }
            @media (max-width: 1280px) { 
                .m-detail-wrap,
                .m-complete-wrap {
                    width: 100%;
                    min-width: 1024px;
                }
                .stu-info {
                    width: 55.09%!important;
                }
            }
            @media (max-width: 1200px) {
                .stu-info {
                    width: 50.09%!important;
                }
            }
            .m-detail .section-item-title-r >span {
                // background-image: url(../../common/images/ic_learning_time_normal.png);
                background-repeat: no-repeat;
                background-position: 0px 2px;
                background-size: 18px 18px;
                padding-left: 22px;
                font-size: 14px;
                color: #333333;
            }
            .m-detail-ing strong{
                font-size: 18px;
                color: #00BBDD;
                font-weight: normal;
            }   
            .m-detail-ing-warn strong {
                font-size: 18px;
                color: #FF6600;
                font-weight: normal;
            }
            .m-detail-end {
                color: #999!important;
            }

            .det-book {
                padding-bottom: 4px;
                padding-top: 20px;
            }
            .det-book-con-up {
                height: 127px;
                overflow: hidden;
            }
            .det-show-btn .close-up {
                display: none;
            }
            .det-show-btn,
            .comp-show-btn {
                text-align: center;
                font-size: 14px;
                color:#00BBDD;
                cursor: pointer;
            }
            .det-show-btn .close-up img {
                position: relative;
                /* top:2px; */
            }
            .det-book .book-info {
                display: flex;
                /* padding-left: 14px; */
                margin-bottom: 43px;
            }
            .det-book .book-info >img {
                width: 80px;
                height: 80px;
                border-radius: 7px;
            }
            .det-book .book-info .book-con {padding-left: 20px;display: flex;flex-direction: column;justify-content: space-between;}
            .det-book .book-info .book-con .book-name {
                font-size: 28px;
                color: #fff;
                font-weight: 700;
                text-align: left;
            }
            .det-book .book-info .book-con .book-author span{
                font-size: 24px;
                color: #9B9B9B;
                margin-right: 20px;
            }


            .book-section {
                font-size: 1.5rem;
                line-height: 1.5rem;
            }

            .book-section .sec-title {
                color: #fff;
                display: flex;
                align-items: center;
                margin-bottom: 16px;
            }
            .book-section .sec-title >img{
                width: 2rem;
                height: 2rem;
                margin-right: 8px;
            }
            .book-list >ul {
                padding-left: 40px;
            }
            .book-list >ul >li >span::before {
                content: '';
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #00BBDD;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: -28px;
            }
            .book-list >ul >li >span{
                color: #e1e1e1;
                display: flex;
                align-items: center;
                position: relative;
                margin-bottom: 20px;
            }
            .book-list >ul >li > ul > li {
                color: #9B9B9B;
                display: flex;
                align-items: center;
                margin-bottom: 20px;
            }

            .book-demand {
                margin-top: 24px;
                margin-bottom: 42px;

                .sec-con {
                    color: #E1E1E1;
                    text-align: left;
                    padding-left: 40px;
                }
            }

            // 学生完成情况
            .m-complete {
                padding: 40px 40px 2px 40px;
                background-color: #252525;
                line-height: 28px
                
            }
            .m-complete-null .filter-box{
                color: #646464;

                &.filter-content >span {
                    border-right-color: #646464!important;
                }

                // &::before{
                //     border-bottom-color: #646464;
                // }
                // &::after{
                //     border-top-color: #646464;
                // }
            }
            .m-complete .section-item-title {
                height: 68px;
                display: flex;
                align-items: normal;
                position: relative;
                .section-item-title-l,
                .section-item-title-r{
                    position: absolute;
                    top:0px;
                }
                .section-item-title-l {
                    left: 0;
                }
                .section-item-title-r {
                    right: 0;
                }
                .section-item-title-l::before {
                    top:0;
                    transform: translateY(0);
                }
            }

            .m-complete .section-item-con .stu-null {
                display: flex;
                padding-top: 160px;
                padding-bottom: 200px;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                img {
                    width: 287px;
                    height: 217px;
                }

                p {
                    font-size: 24px;
                    color: #fff;
                    margin-top: 30px;
                }
            }
            .m-complete .section-item-con >ul{
                display: block;
            }

            .m-complete .section-item-title .section-item-title-r {
                font-size: 18px;
                line-height: 28px;
            }

            .filter-box {
                position: relative;
                // &::before,
                // &::after {
                //     right: -17px;
                //     content: '';
                //     position: absolute;
                //     border: 5px solid transparent;
                // }

                // &::before {
                //     top: -9px;
                //     border-bottom-color: #4a7fb5;
                //     border-bottom-width: 9px;
                // }
                // &::after {
                //     top: 11px;
                //     border-top-color:rgb(150, 150, 150);
                //     border-top-width: 9px;
                // }
            }

            .stu-item-level1 .stu-info-bar-inner {
                background-image: linear-gradient(138deg, #FE6B8E 0%, #FEB1C5 100%);
                margin-top: auto;
            }
            .stu-item-level2 .stu-info-bar-inner {
                background-image: linear-gradient(133deg, #FDC01C 0%, #FBE18B 100%);
            }
            .stu-item-level3 .stu-info-bar-inner {
                background-image: linear-gradient(133deg, #47A9F5 0%, #BEE7FF 100%);
            }
            .stu-item-level1 .stu-pro-num {
                color: #FF7791;
            }
            .stu-item-level2 .stu-pro-num {
                color: #FFB22E;
            }
            .stu-item-level3 .stu-pro-num {
                color: #4BA5EB;
            }

            .stu-item {
                /* padding: 0 20px 0 34px; */
                display: flex;
                align-items: center;
                height: 100px;
                justify-content: space-between;
                background: #333333;
                border-radius: 8px;
                padding: 0 20px;
                margin-bottom: 20px;
            }
            .stu-img {
                width: 60px;
                height: 60px;
                margin-right: 20px;
                border-radius: 50%;
            }
            .stu-info {
                width: 649px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                text-align: left;
                font-size: 22px;
                line-height: 22px;
                .stu-name {
                    display: flex;
                    margin-bottom: 13px;

                    >span:nth-child(1) {
                        color: #fff;
                        margin-right: 12px;
                        max-width: 220px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        display: inline-block;
                        line-height: 25px;
                    }

                    >span:nth-child(2) {
                        color: #666666;
                        max-width: 200px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        display: inline-block;
                        line-height: 25px;
                    }

                    .stu-pro-text {
                        font-size: 16px;
                        line-height: 16px;
                        margin-left: auto;
                        color:#fff;
                        display: flex;
                        display: table-cell;
                        vertical-align: bottom;

                        /deep/ strong {
                            font-family: DINAlternate-Bold;
                            font-size: 24px;
                            // line-height: 26px;
                            margin-right: 8px;
                            margin-left: 8px;
                            margin-top: auto;
                        }
                        /deep/ span {
                            margin-top: auto;
                        }
                    }
                }

                .stu-info-pro {
                    display: flex;
                    .stu-info-bar {
                        background-color: #F5F5F5;
                        border-radius: 10px;
                        height: 14px;
                        width: 87.82%;
                        margin-top: auto;
                        margin-bottom: auto;

                        .stu-info-bar-inner {
                            height: 100%;
                            border-radius: 10px;
                        }
                    }
                    .stu-pro-num {
                        // color:#fff;
                        margin-left: auto;
                        font-size: 22px;
                        line-height: 22px;
                        font-family: DINAlternate-Bold;
                    }
                }
            }   

            .stu-type {
                display: flex;
                flex-direction: column;
                font-size: 18px;
                line-height: 15px;
                color: #969696;
                margin-left: auto;
                margin-right: auto;
                height: 52px;
                justify-content: space-between;

                >span:nth-child(2) {
                    margin-top: auto;   
                }
            }

            .stu-time{
                /* margin-left: auto; */
                border-radius: 6px 0 0 6px;
            }
            .stu-num{
                border-radius: 0 6px 6px 0px;
            }
            .stu-time ,
            .stu-test ,
            .stu-num  {
                height: 60px;
                display: flex;
                flex-direction: column;
                text-align: center;
                color: #fff;
                width: 103px;
                padding-bottom: 7px;
                padding-top: 9px;
                justify-content: space-between;
                background: #666;

            }
            .stu-time .stu-time-num ,
            .stu-test .stu-test-num ,
            .stu-num .stu-num-num  {
                height: 20px;
                font-size: 14px;
                text-align: center;

                /deep/ strong {
                    font-family: DINAlternate-Bold;
                    font-size: 20px;
                    color: #fff;
                    margin-right: 4px;
                    vertical-align: top;
                }
                /deep/ span {
                    font-size: 12px;
                    color: #E1E1E1;
                }
            }
            .stu-time .stu-time-num span,
            .stu-test .stu-test-num span,
            .stu-num .stu-num-num span {
                font-size: 12px;
                color: #4A4A4A;
            }
            .stu-time .stu-time-des,
            .stu-test .stu-test-des,
            .stu-num .stu-num-des {
                font-size: 12px;
                color: #9B9B9B;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .stu-time .stu-time-des img,
            .stu-test .stu-test-des img,
            .stu-num .stu-num-des img {
                width: 12px;
                height: 12px;
                margin-right: 4px;
            }
        }

        // 学习报告
        .learn-report {
            flex: 1;
            display: flex;
            background-color: #252525;
            section {
                width: 1280px;
                margin: 0 auto;
            }
            @media (max-width: 1280px) { 
                section {
                    width: 100%;
                    min-width: 1024px;
                }
                .tb-tl,
                .tb-bl {
                    width: 65.97%!important;
                }
                .tb-tr,
                .tb-br{
                    width: 31.95%!important;
                }
            }
            // 全书学习
            .totle-book {
                padding: 30px 30px 58px 30px;
                /deep/ strong {
                    font-size: 36px;
                    line-height: 32px;
                    font-weight: 700;
                }
                .tb-tl,
                .tb-tr,
                .tb-bl .l-item,
                .tb-br {
                    border-radius: 8px;
                    background: #323232;
                }
                .tb-t {
                    display: flex;
                    justify-content: space-between;
                    height: 396px;

                    .tb-tl {
                        width: 806px;
                        display: flex;
                        flex-direction: column;

                        .tl-book{
                            padding: 30px 0 26px 40px;
                            display: flex;
                            border-bottom: 2px solid #252525;
                            .book-img{
                                width: 132px;
                                height: 132px;
                                border: 1px solid #F2F2F2;border-radius: 5.6px;
                            }
                            .tl-book-info {
                                flex: 1;
                                display: flex;
                                justify-content: center;
                                flex-direction: column;
                                align-items: center;
                                color: #fff;

                                .info-name {
                                    font-size: 24px;
                                    line-height: 30px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    max-width: 400px;
                                }
                                .info-des {
                                    font-size: 20px;
                                    line-height: 24px;
                                    margin: 18px 0 8px 0;
                                }
                                .info-level{        
                                    font-size: 32px;
                                    line-height: 40px;
                                    font-weight: 700;
                                    position: relative;

                                    &::before,
                                    &::after{
                                        content: '';
                                        background-size: 100% 100%;
                                        position: absolute;
                                        top: -27px;
                                        width: 51px;
                                        height: 69px;
                                    }
                                    &::before{
                                        background-image: url('../assets/image/icon_olive40-79_left@2x.png');
                                        left: -100px;
                                    }
                                    &::after{
                                        background-image: url('../assets/image/icon_olive40-79_right@2x.png');
                                        right: -100px;
                                    }
                                }
                            }
                        }
                        .tl-summary {
                            display: flex;
                            flex-wrap: wrap;
                            flex: 1;
                            padding: 0 30px;

                            .summary-item {
                                width: 50%;
                                height: 50%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                font-size: 24px;
                                line-height: 30px;

                                .summary-item-num {
                                    color: #FFFFFF;
                                    margin-bottom: 6px;
                                    font-weight: 700;
                                }
                                .summary-item-des {
                                    color: #999999;
                                }
                                &:nth-child(1),
                                &:nth-child(2) {
                                    padding-top: 26px;
                                }
                                &:nth-child(3),
                                &:nth-child(4) {
                                    padding-bottom: 30px;
                                }
                                /deep/ strong {
                                    font-size: 24px;
                                    line-height: 30px;
                                    font-weight: inherit;
                                }
                            }
                        }
                    }
                    .tb-tr{
                        width: 394px;
                    }
                }
                .tb-r {
                    padding-left: 30px;
                    font-size: 24px;
                    line-height: 28px;  
                    .r-title {
                        color: #999999;
                        height: 100px;
                        display: flex;
                        align-items: center;
                        font-size: 24px;
                        img {
                            width: 36px;
                            height: 36px;
                            margin-right: 10px;
                        }
                    }
                    .r-item {
                        display: flex;
                        flex-direction: column;
                        .r-item-des {
                            color: #999999;
                        }
                        .r-item-num {
                            margin-top: 30px;
                            color: #fff;
                            /deep/ strong {
                                font-size: 36px;
                                line-height: 32px;
                            }
                        }
                        &:nth-child(3) {
                            margin-top: 66px;
                        }
                    }
                }
                .tb-b {
                    display: flex;
                    margin-top: 20px;
                    justify-content: space-between;
                    .tb-bl {
                        width: 806px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        .l-item{
                            width: calc(50% - 10px);
                            height: 188px;
                            padding-left: 30px;
                            display: flex;
                            flex-direction: column;
                            margin-bottom: 20px;

                            &:nth-child(3),
                            &:nth-child(4) {
                                margin-bottom: 0;
                            }
                            .l-item-title {
                                font-size: 24px;
                                color: #999999;
                                line-height: 28px;
                                height: 100px;
                                display: flex;
                                align-items: center;
                                img {
                                    width: 36px;
                                    height: 36px;
                                    margin-right: 10px;
                                }
                            }
                            .l-item-value {
                                flex: 1;
                                font-size: 24px;
                                color: #FFFFFF;
                                line-height: 32px;
                                display: flex;
                                padding-bottom: 42px;
                                align-items: center;
                            }
                        }
                    }

                    .tb-br {
                        width: 394px;
                    }
                }
            }

            // 章节学习
            .section-learn {
                width: 100%;
                .section-learn-top{
                    padding: 60px 0px 45px;
                    display: flex;
                    justify-content: center;
                    position: relative;
                    
                    .top-l,
                    .top-r {
                        width: 18.5rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .top-value {
                            font-size: 2.375rem;
                            color: #FFFFFF;
                            font-weight: 700;
                            line-height: 2.375rem;
                            text-align: center;
                            margin-bottom: 19px;
                            /deep/ strong{
                                font-weight: 700;
                            }
                        }
                        .top-des {
                            font-size: 1.5rem;
                            color: #E1E1E1;
                            text-align: center;
                        }
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        top: 45%;
                        left: 50%;
                        // transform: translate(-50%, -50%);
                        width: 2px;
                        height: 2.5rem;
                        background: #666666;
                        border-radius: 2px;
                    }
                }

                .secion-learn-con {
                    padding: 0 20px 0 40px;
                    >ul {
                        width: 1820px;
                        margin: 0 auto;
                    }
                    @media (max-width: 1900px) {
                        >ul {
                            width: 1510px;
                            margin: 0 auto;
                        }
                    }
                    @media (max-width: 1590px) {
                        >ul {
                            width: 1208px;
                            margin: 0 auto;
                        }
                    }
                    @media (max-width: 1270px) {
                        >ul {
                            width: 906px;
                            margin: 0 auto;
                        }
                    }
                    .chapter-item {
                        margin-bottom: 21px;
                        .chapter-title {
                            font-size: 1.5rem;
                            color: #FFFFFF;
                            line-height: 1.5rem;
                            margin-bottom: 24px;
                        }
                        .chapter-info {
                            >ul {
                                display: flex;
                                // justify-content: space-between;
                                flex-wrap: wrap;
                                li {
                                    display: flex;
                                    float: left;
                                    background: #323232;
                                    border-radius: 4px;
                                    width: 282px;
                                    height: 110px;
                                    align-items: center;
                                    padding-left: 30px;
                                    margin-bottom: 20px;
                                    margin-right: 20px;
                                    >img {
                                        width: 70px;
                                        height: 70px;
                                        background-color: #464646;
                                        border-radius: 50%;
                                    }
                                    .chapter-info-detail{
                                        display: flex;
                                        flex-direction: column;
                                        color: #fff;
                                        padding-left: 20px;
                                        span{
                                            font-size: 18px;
                                            line-height: 18px;
                                        }
                                        .detail-des{
                                            margin-bottom: 14px;
                                        }
                                        .detail-value {
                                            opacity: 0.8;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // 视频学习
            .video-learn {
                background: #191919;
                width: 100%;
                .video-learn-top {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    background-color: #252525;
                    border-bottom: 20px solid #191919;
                    >span:nth-child(1) {
                        font-size: 2.375rem;
                        color: #FFFFFF;
                        line-height: 2.375rem;
                        margin-bottom: 20px;
                        font-weight: 700;
                        padding-top: 60px;
                    }
                    >span:nth-child(2) {
                        font-size: 1.5rem;
                        color: #9B9B9B;
                        padding-bottom: 40px;
                    }
                }
                .video-learn-info {
                    background-color: #252525;
                    >ul {
                        >li {                            
                            border-bottom: 30px solid #191919;
                            &:nth-last-child(1) {
                                border: none;
                            }
                        }
                        @media (max-width: 1280px) {
                            .video-item{
                                width: 100%!important;
                                min-width: 1024px;
                            }
                        }
                        .video-item {
                            width: 1280px;
                            margin: 0 auto;
                            color: #FFFFFF;
                            padding: 0 60px 0 40px;
                            .chapter-name {
                                font-size: 1.75rem;
                                line-height: 1.75rem;
                                padding: 20px 0px;
                                display: flex;
                                align-items: center;
                                font-weight: 700;
                                border-bottom: 1px solid #646464;
                            }
                            >ul{
                                padding-left: 40px;
                            }

                            .video-sub-item {
                                padding: 20px 0 20px 0px;
                                font-size: 1.5rem;
                                line-height: 1.5rem;
                                display: flex;
                                border-bottom: 1px solid #646464;

                                &:nth-last-child(1){
                                    border-bottom-width: 0px;
                                } 
                                .video-sub-item-value {
                                    margin-left: auto;
                                }
                            }
                        }
                    }
                }
            }

            // 练习测试
            .test {
                background: #191919;
                width: 100%;
                .test-top {
                    padding: 45px 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #252525;
                    border-bottom: 30px solid #191919;
                    .test-top-item {
                        display: flex;
                        flex-direction: column;
                        width: 10.4rem;
                        &:nth-child(2) {
                            margin: 0 100px;
                            position: relative;
                            &::before,
                            &::after {
                                content: '';
                                width: 2px;
                                height: 40px;
                                background-color: #666;
                                border-radius: 2px;
                                position: absolute;
                                top:50%;
                                transform: translateY(-50%);
                            }
                            &::before {
                                left: -50px;
                            }
                            &::after {
                                right: -50px;
                            }
                        }
                        .test-top-value {
                            font-size: 2.375rem;
                            color: #FFFFFF;
                            line-height: 2.375rem;
                            font-weight: 700;
                            margin-bottom: 19px;
                            text-align: center;
                        }
                        .test-top-des {
                            font-size: 1.5rem;
                            color: #9B9B9B;
                            text-align: center;
                        }
                    }
                }
                .test-info {
                    background-color: #252525;
                    >ul {
                        >li {                            
                            border-bottom: 30px solid #191919;
                            overflow-x: hidden;
                            overflow-y: hidden;
                            .gap {
                                height: 30px;
                                background-color: #191919;
                            }
                        }
                        @media (max-width: 1280px) {
                            .test-item {
                                width: 100%!important;
                                min-width: 1024px;;
                            }
                        }
                        .test-item {
                            width: 1280px;
                            margin: 0 auto;
                            color: #FFFFFF;
                            padding: 0 60px 0 40px;

                            .chapter-name {
                                font-size: 1.75rem;
                                line-height: 1.75rem;
                                padding: 20px 0;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                display: block;
                                border-bottom: 1px solid #646464;
                                font-weight: 700;
                            }
                            >ul{
                                padding-left: 40px;
                            }

                            .test-sub-item {
                                padding: 20px 0 20px 2.325rem;
                                font-size: 1.5rem;
                                line-height: 1.5rem;
                                display: flex;
                                flex-wrap: wrap;
                                border-bottom: 1px solid #646464;
                                &.test-sub-item-big {
                                    .section-name,
                                    .test-sub-item-value {
                                        font-size: 1.75rem!important;
                                        line-height: 1.75rem!important;
                                    }
                                    .test-sub-item-value {
                                        display: none;
                                    }
                                    .i-test::before {
                                        width: 1.75rem!important;
                                        height: 1.75rem!important;
                                        font-size: 1.25rem!important;
                                        line-height: 1.25rem!important;
                                    }
                                }

                                &:nth-last-child(1){
                                    border-bottom-width: 0px;
                                    
                                } 
                                .section-name {
                                    position: relative;
                                }
                                .i-test::before,
                                .i-practice::before{
                                    width: 1.5rem;
                                    height: 1.5rem;
                                    border-radius: 3.43px;
                                    position: absolute;
                                    top: 0;
                                    left: -2.125rem;
                                    font-size: 1.0625rem;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                .i-practice::before {
                                    content: '练';
                                    background: #29BCCB;
                                    
                                }
                                .i-test::before {
                                    content: '测';
                                    background: #FF8A48;
                                }
                                .test-sub-item-value {
                                    margin-left: auto;
                                }
                                .test-detail {
                                    width: 100%;
                                    height: 100%;
                                    .detail-top {
                                        padding: 37px  0 42px 0;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        position: relative;
                                        margin-right: 74px;
                                        &::before {
                                            content: '';
                                            width: 2px;
                                            height: 40px;
                                            background: #666666;
                                            border-radius: 2px;
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            transform: translate(-50%, -50%);
                                        }
                                        .detail-top-l,
                                        .detail-top-r {
                                            // width: 235px;
                                            // height: 100px;
                                            display: flex;
                                            flex-direction: column;
                                            
                                            >span:nth-child(1) {
                                                font-size: 2.375rem;
                                                font-weight: 700;
                                                line-height: 2.375rem;
                                                margin-bottom: 19px;
                                                text-align: center;
                                            }
                                            >span:nth-child(2) {
                                                font-size: 1.5rem;
                                                color: #E1E1E1;
                                                text-align: center;
                                                white-space: nowrap;
                                            }
                                        }
                                        .detail-top-l {
                                            margin-right: 50px;
                                            >span:nth-child(1) {
                                                color: #29BCCB;
                                            }
                                        }
                                        .detail-top-r {
                                            >span:nth-child(1) {
                                                color: #FF8A48;
                                            }
                                        }
                                    }
                                    .detail-list {
                                        li {
                                            padding: 20px 0;
                                            display: flex;
                                            justify-content: space-between;
                                            font-size: 1.5rem;
                                            color: #FFFFFF;
                                            line-height: 1.5rem;
                                            &:nth-child(1) {
                                                font-size: 1.75rem;
                                                color: #FFFFFF;
                                                line-height: 1.75rem;
                                                font-weight: 700;
                                            }
                                            &:nth-last-child(1) {
                                                padding-bottom: 0px;
                                            }
                                            &+li{
                                                border-top: 1px solid #333;
                                            }
                                            &.best {
                                                .detail-date {
                                                    color: #FF8A48;
                                                    position: relative;
                                                    &::after {
                                                        content: '最优';
                                                        line-height: 0.875rem;
                                                        font-size: 0.875rem;
                                                        background: #FF8A48;
                                                        border-radius: 2.4px;
                                                        width: 2.25rem;
                                                        height: 1.5rem;
                                                        color: #fff;
                                                        display: flex;
                                                        justify-content: center;
                                                        align-items: center;
                                                        position: absolute;
                                                        right: -2.81rem;
                                                        top: 0;
                                                    }
                                                }
                                                .detail-value span{
                                                    color: #FF8A48;
                                                }
                                            }
                                            &.new {
                                                .detail-date {
                                                    color: #29BCCB;
                                                    position: relative;
                                                    &::after {
                                                        content: '最新';
                                                        line-height: 0.875rem;
                                                        font-size: 0.875rem;
                                                        background: #29BCCB;
                                                        border-radius: 2.4px;
                                                        width: 2.25rem;
                                                        height: 1.5rem;
                                                        color: #fff;
                                                        display: flex;
                                                        justify-content: center;
                                                        align-items: center;
                                                        position: absolute;
                                                        right: -2.81rem;
                                                        top: 0;
                                                    }
                                                }
                                                .detail-value span{
                                                    color: #29BCCB;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // 暂无记录
            .no-data {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 24px;
                flex-direction: column;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                >img {
                    margin-bottom: 50px;
                    width: 200px;
                    height: 200px;
                }
            }
        }
    }
}

</style>